import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GlobalProvider from './contexts'
import { MuiThemeProvider } from '@material-ui/core/styles';
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import theme from './theme'
import ContainerApp from './components/ComponentsForApp/ContainerApp/ContainerApp';
import Login from './components/ComponentsForPage/Login/Login';
import SetPassword from './components/ComponentsForPage/SetPassword/SetPassword';
import RootRedirect from './components/ComponentsForProtectRoutes/RootRedirect';
import { urls } from './urls';

function App() {
  return (
    <MuiThemeProvider theme={theme}>
      <GlobalProvider>
        <SubApp />
        <ToastContainer />
      </GlobalProvider>
    </MuiThemeProvider>
  );
}

function SubApp() {
  return (
    <Router>
      <Routes>
        <Route path={urls.page.home} element={<RootRedirect />} />
        <Route path={urls.page.login} element={<Login />} />
        <Route path={urls.page.setPassword} element={<SetPassword />} />

        <Route path='/app/*' element={<ContainerApp />}>
        </Route>
      </Routes>
    </Router>
  )
}

export default App;
